<template>
  <v-container id="schedule-detail">
    <div class="page-title">{{ $route.name }}</div>

    <v-row justify="center">
      <div class="container-wrapper">
        <v-container>
          <v-row justify="end">
            <v-menu
              :close-on-content-click="false"
              v-model="dateMenu"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <div style="width:250px; margin-right:20px;">
                  <v-text-field
                    v-model="selectedDate"
                    prepend-icon="event"
                    readonly
                    dense
                    v-on="on"
                  ></v-text-field>
                </div>
              </template>
              <c-date-picker
                v-model="selectedDate"
                firstDayOfWeek="1"
                :selectedDate="selectedDate"
                noTitle="true"
                scrollable="true"
                locale="ko-kr"
                @input="dateMenu = false"
              ></c-date-picker>
            </v-menu>
            <v-spacer></v-spacer>
            <c-btn
              color="grey"
              outlined
              iconName="mdi-format-list-bulleted-square"
              @click="$router.go(-1)"
            >
              돌아가기
            </c-btn>
          </v-row>
        </v-container>

        <c-scheduler
          :headerList="getHeaderList"
          :contentList="newSchedulerContentList"
          :guideLine="null"
          @onClickContentRow="onClickSchedule"
          :contentsHeight="calHeight"
        >
          <template #mainContent="{item}">
            <div>
              <span
                >{{ item.title }}
                <v-icon v-if="noteCheck(item)" size="20">bookmark</v-icon>
              </span>
            </div>
          </template>
          <template #contentItem="{item}">
            <!-- 휴식, 휴식 시간 있으면 해당  추가 -->

            <v-tooltip v-if="item.item.restInfo" bottom>
              <template v-slot:activator="{ on: onTooltip }">
                <div
                  v-if="item.item.restInfo"
                  :style="{
                    marginLeft: `${item.item.restInfo.left - item.left}px`,
                    width: `${item.item.restInfo.width}px`,
                    backgroundColor: '#2cccc7',
                    height: '100%',
                  }"
                  v-on="onTooltip"
                ></div>
              </template>
              <span>휴식 시작: {{ item.item.restInfo.startRestTime }}</span>
              <br />
              <span>휴식 종료: {{ item.item.restInfo.endRestTime }}</span>
              <br />
              <span v-if="item.item.restInfo.restNote"
                >메모: {{ item.item.restInfo.restNote }}</span
              >
              <br v-if="item.item.restInfo.restNote" />
            </v-tooltip>
          </template>
        </c-scheduler>
      </div>
    </v-row>

    <v-dialog v-model="contentDialog" hide-overlay persistent width="380">
      <c-card class="white">
        <v-row justify="center" class="ma-5 title font-weight-bold"
          >근무 일정 설정</v-row
        >
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="onSettingDriverSchedule"
            >근무 일정 등록 / 변경</c-btn
          >
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="blue" large block @click="onSettingDriverRest"
            >휴식 일정 등록 / 변경</c-btn
          >
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn
            color="blue"
            large
            block
            @click="onReplaceDriverSchedule"
            :disabled="checkReplaceScheduleBtn"
            >일정 이동</c-btn
          >
        </v-row>
        <v-row justify="center" class="ma-3">
          <c-btn color="grey" large block @click="contentDialog = false"
            >취소</c-btn
          >
        </v-row>
      </c-card>
    </v-dialog>

    <schedule-replace-dialog
      :open.sync="scheduleReplaceDialogOpen"
      :selectedRow="selectedRow"
      :selectedDate="selectedDate"
      @replaceSchedule="replaceSchedule"
    >
    </schedule-replace-dialog>

    <schedule-c-u-dialog
      :open.sync="schedulerCUDialogOpen"
      :selectedSchedule="selectedSchedule"
      :selectedDate="selectedDate"
      @reqUpdateSchedule="reqUpdateSchedule"
      @refetchData="refetchData"
    />

    <rest-c-u-dialog
      :open.sync="restCUDialogOpen"
      :selectedSchedule="selectedSchedule"
      :selectedDate="selectedDate"
      @addEditDriveRestSchedule="addEditDriveRestSchedule"
      @refetchData="refetchData"
    />
  </v-container>
</template>

<script>
import CScheduler from "../Common/CScheduler";
import ScheduleCUDialog from "./ScheduleCUDialog";
import ScheduleReplaceDialog from "./ScheduleReplaceDialog";
import RestCUDialog from "./RestCUDialog";

export default {
  components: {
    CScheduler,
    ScheduleCUDialog,
    ScheduleReplaceDialog,
    RestCUDialog,
  },
  data() {
    return {
      dateMenu: false,
      selectedDate: this.$route.params.date,

      schedulerContentList: [],
      newSchedulerContentList: [],
      schedulerHeaders: [0, 24],
      schedulerOneHourWidth: 60,

      selectedSchedule: null,
      schedulerCUDialogOpen: false,
      scheduleReplaceDialogOpen: false,

      restCUDialogOpen: false,

      calHeight: 0,
      contentDialog: false,
      selectedRow: {},
      checkReplaceScheduleBtn: false,
      vehicleName: "",
    };
  },
  watch: {
    selectedDate(newVal) {
      this.getNewDriverSchedule(newVal);
    },
  },
  computed: {
    getHeaderList() {
      let headerList = [];
      for (
        let i = this.schedulerHeaders[0];
        i < this.schedulerHeaders[1];
        i++
      ) {
        headerList.push(this.$moment({ hour: i }).format("HH:00"));
      }
      return headerList;
    },
  },
  methods: {
    refetchData() {
      this.onCalHeight();
      this.getNewDriverSchedule(this.selectedDate);
    },
    areTitlesEqual(subContent1, subContent2) {
      return subContent1.title === subContent2.title;
    },
    async getNewDriverSchedule(selectedDate) {
      //new 기사 근무 일정
      const res = await this.$api.getNewDriverSchedule(selectedDate);
      const scheduleList = res.data;
      let contentList = [];

      const workOffColor = "#808080";
      const otherScheduleColor = "#e1e1e1";
      contentList = scheduleList.map((v) => {
        let width = 0;
        let left = 0;
        let restWidth = 0;
        let restLeft = 0;
        let color = "#0070c0";
        let items = [];

        const centerId = JSON.parse(localStorage.getItem("vuex")).centerInfo
          .centerId;

        if (v.scheduleInfo) {
          const diff = this.$moment
            .duration(
              this.$moment(v.scheduleInfo.endWorkTime, "HH:mm").diff(
                this.$moment(v.scheduleInfo.startWorkTime, "HH:mm")
              )
            )
            .asHours();
          if (diff === 0) {
            width =
              this.schedulerOneHourWidth *
              (this.schedulerHeaders[1] - this.schedulerHeaders[0]);
            color = workOffColor;
          } else if (diff > 0) {
            width = diff * this.schedulerOneHourWidth;
            const diffWithStart = this.$moment
              .duration(
                this.$moment(v.scheduleInfo.startWorkTime, "HH:mm").diff(
                  this.$moment(this.schedulerHeaders[0], "H")
                )
              )
              .asHours();
            left = diffWithStart * this.schedulerOneHourWidth;
          }
        }

        if (v.restInfo) {
          const diff = this.$moment
            .duration(
              this.$moment(v.restInfo.endRestTime, "HH:mm").diff(
                this.$moment(v.restInfo.startRestTime, "HH:mm")
              )
            )
            .asHours();

          restWidth = diff * this.schedulerOneHourWidth;
          const diffWithStart = this.$moment
            .duration(
              this.$moment(v.restInfo.startRestTime, "HH:mm").diff(
                this.$moment(this.schedulerHeaders[0], "H")
              )
            )
            .asHours();
          restLeft = diffWithStart * this.schedulerOneHourWidth;
        }

        return {
          title: v.driverVehicleInfo.driverName,
          subContents: [
            {
              title: v.driverVehicleInfo.plateNo,
              items: [
                {
                  color,
                  left,
                  width,
                  item: {
                    driverId: v.driverVehicleInfo.driverId,
                    vehicleId: v.driverVehicleInfo.vehicleId,
                    driverSchedule: v.scheduleInfo
                      ? {
                          id: v.scheduleInfo.driverScheduleId,
                          centerId: centerId, //localStorage.getItem("vuex").centerInfo.centerId,
                          scheduleDate: this.selectedDate, //this.$route.params.id,
                          onWorkTime: v.scheduleInfo.startWorkTime,
                          endWorkTime: v.scheduleInfo.endWorkTime,
                          scheduleNote: v.scheduleInfo.scheduleNote,
                          noWork: false,
                        }
                      : null,
                    restInfo: v.restInfo
                      ? { ...v.restInfo, width: restWidth, left: restLeft }
                      : null,
                  },
                },
              ],
            },
          ],
        };
      });
      const groupedDataMap = new Map();

      //기사가 두개이상의 차량에 배정되어있을경우
      contentList.forEach((item) => {
        const title = item.title;
        if (!groupedDataMap.has(title)) {
          groupedDataMap.set(title, []);
        }
        groupedDataMap.get(title).push(item.subContents[0]);
      });

      const groupedData = Array.from(
        groupedDataMap,
        ([title, subContents]) => ({ title, subContents })
      );

      //해당 차량으로 다른 기사의 근무 일정이 잡혀있는 경우
      for (let i = 0; i < groupedData.length; i++) {
        for (let j = i + 1; j < groupedData.length; j++) {
          if (
            groupedData[i].subContents[0].title ===
            groupedData[j].subContents[0].title
          ) {
            groupedData[j].subContents[0].items[0].color = otherScheduleColor;
            groupedData[j].subContents[0].items[0].left =
              groupedData[i].subContents[0].items[0].left;
            groupedData[j].subContents[0].items[0].width =
              groupedData[i].subContents[0].items[0].width;
          }
        }
      }

      this.newSchedulerContentList = groupedData;
    },
    //전 기사근무일정
    async reqGetDriverScheduleList(selectedDate) {
      try {
        const res = await this.$api.getDailyDriveSchedule(
          selectedDate || this.selectedDate
        );

        let contentList = [];
        for (let i = 0; i < res.data.length; i++) {
          const workOffColor = "#808080";
          const otherScheduleColor = "#e1e1e1";

          const driver = res.data[i].driver;
          const vehicleList = res.data[i].vehicleList;
          let subContents = [];

          for (let j = 0; j < vehicleList.length; j++) {
            const item = vehicleList[j];

            const {
              driverType,
              vehicle,
              driverSchedule,
              otherDriverSchedule,
            } = item;

            let width = 0;
            let left = 0;
            let color = this.getScheduleColor(driverType);
            let items = [];
            //TODO - Color
            if (otherDriverSchedule && otherDriverSchedule.length > 0) {
              for (const other of otherDriverSchedule) {
                const { onWorkTime, endWorkTime } = other;

                const diff = this.$moment
                  .duration(
                    this.$moment(endWorkTime, "HH:mm").diff(
                      this.$moment(onWorkTime, "HH:mm")
                    )
                  )
                  .asHours();

                if (diff === 0) {
                  // 휴무
                  // width = this.schedulerOneHourWidth * (this.schedulerHeaders[1] - this.schedulerHeaders[0]);
                  // color = "#e1e1e1";
                  continue;
                } else if (diff > 0) {
                  width = diff * this.schedulerOneHourWidth;
                  const diffWithStart = this.$moment
                    .duration(
                      this.$moment(onWorkTime, "HH:mm").diff(
                        this.$moment(this.schedulerHeaders[0], "H")
                      )
                    )
                    .asHours();
                  left = diffWithStart * this.schedulerOneHourWidth;
                }
                items.push({
                  color: otherScheduleColor,
                  width,
                  left: left < 0 ? 0 : left,
                  item: {
                    driverId: driver.id,
                    vehicleId: vehicle.id,
                  },
                });
              }
            }

            width = 0;
            left = 0;
            if (driverSchedule) {
              const { onWorkTime, endWorkTime } = driverSchedule;

              const diff = this.$moment
                .duration(
                  this.$moment(endWorkTime, "HH:mm").diff(
                    this.$moment(onWorkTime, "HH:mm")
                  )
                )
                .asHours();

              if (diff === 0) {
                // 휴무
                width =
                  this.schedulerOneHourWidth *
                  (this.schedulerHeaders[1] - this.schedulerHeaders[0]);
                color = workOffColor;
              } else if (diff > 0) {
                width = diff * this.schedulerOneHourWidth;
                const diffWithStart = this.$moment
                  .duration(
                    this.$moment(onWorkTime, "HH:mm").diff(
                      this.$moment(this.schedulerHeaders[0], "H")
                    )
                  )
                  .asHours();
                left = diffWithStart * this.schedulerOneHourWidth;
              }
            }
            items.push({
              color,
              width,
              left: left < 0 ? 0 : left,
              item: {
                driverId: driver.id,
                vehicleId: vehicle.id,
                driverSchedule,
              },
            });

            subContents.push({
              title: vehicle.plateNo,
              items,
            });
          }

          contentList.push({
            title: driver.name,
            subContents,
          });
        }

        // 기사 이름 오른차순 sorting
        contentList.sort((a, b) => (a.title > b.title ? 1 : -1));
        this.schedulerContentList = contentList;
      } catch (err) {
        this.$store.commit("snackbar", {
          err,
          where: "reqGetDriverScheduleList",
        });
      }
    },
    async reqUpdateSchedule(reqData) {
      try {
        const res = await this.$api.updateDriveSchedule(reqData);
        if (reqData.confirm === "t") {
          this.getNewDriverSchedule(this.selectedDate);
        } else {
          // y일 경우 재귀 호출, n일 경우 confirm 다이얼로그만 끈다.
          this.onConfirmDialogOpen(res.data, reqData);
        }
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqUpdateSchedule" });
      }
    },
    async addEditDriveRestSchedule(reqData) {
      try {
        await this.$api.addEditDriveRestSchedule(reqData);
        this.refetchData();
        this.$store.commit("snackbar", {
          color: "blue",
          msg: "휴식 일정 변경이 완료되었습니다.",
        });
      } catch (err) {
        this.$store.commit("snackbar", {
          msg: err.response.data,
        });
      }
    },

    onClickSchedule(selected) {
      this.selectedRow = selected;
      this.contentDialog = true;
      let schedule = this.selectedRow.items[0].item.driverSchedule;
      if (
        !schedule ||
        (schedule.onWorkTime === "00:00" && schedule.endWorkTime === "00:00")
      ) {
        this.checkReplaceScheduleBtn = true;
      } else {
        this.checkReplaceScheduleBtn = false;
      }
    },
    onSettingDriverRest() {
      this.contentDialog = false;
      //운행 종료 일자의 경우 변경 금지

      //선택된 스케줄에 item이 2개 이상일 경우 해당 스케줄만 찾아서 표시 (#e1e1e1색이 아닌 item)
      if (this.selectedRow.items.length > 1) {
        const filter = this.selectedRow.items.filter(
          (item) => item.color !== "#e1e1e1"
        );
        this.selectedSchedule =
          filter && filter.length > 0
            ? filter[0].item
            : this.selectedRow.items[0].item;
      } else this.selectedSchedule = this.selectedRow.items[0].item;

      this.restCUDialogOpen = true;
    },
    onSettingDriverSchedule() {
      this.contentDialog = false;
      //운행 종료 일자의 경우 변경 금지
      if (this.selectedDate < this.$func.curDateString()) {
        return;
      }
      //선택된 스케줄에 item이 2개 이상일 경우 해당 스케줄만 찾아서 표시 (#e1e1e1색이 아닌 item)
      if (this.selectedRow.items.length > 1) {
        const filter = this.selectedRow.items.filter(
          (item) => item.color !== "#e1e1e1"
        );
        this.selectedSchedule =
          filter && filter.length > 0
            ? filter[0].item
            : this.selectedRow.items[0].item;
      } else this.selectedSchedule = this.selectedRow.items[0].item;
      this.schedulerCUDialogOpen = true;
    },
    onReplaceDriverSchedule() {
      this.contentDialog = false;
      this.scheduleReplaceDialogOpen = true;
    },
    replaceSchedule(data) {
      let msg =
        "차량 " +
        this.selectedRow.title +
        " 의 \n" +
        this.selectedRow.items[0].item.driverSchedule.onWorkTime +
        " ~ " +
        this.selectedRow.items[0].item.driverSchedule.endWorkTime +
        " 일정을 이동하시겠습니까?";
      console.log("msg", msg);
      this.$store.commit("alert", {
        open: true,
        persistent: true,
        msg: msg,
        confirm: true,
        callBack: () => {
          this.reqReplaceSchedule(data);
        },
      });
      this.scheduleReplaceDialogOpen = false;
    },
    async reqReplaceSchedule(data) {
      try {
        const res = await this.$api.replaceDriverSchedule(data);
        // 이동완료 snackbar
        this.$store.commit("snackbar", { color: "blue", msg: res.data });
        this.openFlag = false;
        this.getNewDriverSchedule(this.selectedDate);
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqReplaceSchedule" });
      }
    },
    getScheduleColor(driverType) {
      switch (driverType) {
        case "main":
          return "#0070c0";
        case "sub1":
          return "#8FAADC";
        case "sub2":
          return "#9DC3E6";
      }
    },
    onConfirmDialogOpen(msg, data) {
      msg = msg ? msg : "근무 일정을 등록하시겠습니까?";

      this.$store.commit("alert", {
        open: true,
        persistent: true,
        msg: msg,
        confirm: true,
        callBack: () => {
          data.confirm = "t";
          this.reqUpdateSchedule(data);
        },
      });
    },
    onCalHeight() {
      const optionsRightPadding = window.innerWidth / 2 - 521 - 245;
      const height = window.innerHeight - 370;
      this.calHeight = height < 300 ? 300 : height;
      this.optionsRightPadding = optionsRightPadding;
    },
    noteCheck(item) {
      const itemLength = item.subContents.length;
      let i = 0;
      let result = "";

      for (i; i < itemLength; i++) {
        let j = 0;
        let itemsLength = item.subContents[i].items.length;
        for (j; j < itemsLength; j++) {
          const ijthDriverSchedule =
            item.subContents[i].items[j].item.driverSchedule;
          if (ijthDriverSchedule) {
            if (
              ijthDriverSchedule.scheduleNote !== null &&
              ijthDriverSchedule.scheduleNote !== ""
            ) {
              result = "O";
            }
          }
        }
      }

      return result;
    },
  },
  mounted() {
    window.addEventListener("resize", this.onCalHeight);
    this.onCalHeight();
    // this.reqGetDriverScheduleList();
    this.getNewDriverSchedule(this.selectedDate);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onCalHeight);
  },
};
</script>

<style scoped>
.container-wrapper {
  width: 1300px;
  overflow-x: auto;
}

.tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%; /* At the top of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #191919 transparent;
}
</style>
